import styled from 'styled-components';
import { breakpoints } from 'config/config';
import { Drawer, Form } from 'antd';

export const StyledCreateEditUserDrawer = styled(Drawer)`
  .footer {
    display: flex;
    justify-content: right;
    align-items: center;
    gap: 15px;
    .ant-btn {
      border-radius: 3px;
    }
  }

  .ant-form-item-label {
    padding: 0;
  }

  .ant-drawer-header {
    min-height: 113px;
    padding: 45px 40px;
    .ant-drawer-header-title {
      display: flex;
      justify-content: space-between;
      flex-direction: row-reverse;
      .anticon-close {
        svg {
          width: 21px;
          height: 21px;
          color: ${({ theme }) => theme.tagCloseColor};
        }
      }

      .ant-drawer-title {
        max-width: 300px;
        font-weight: 400;
        font-size: 16px;
        color: ${({ theme }) => theme.colorText};
      }
    }
  }

  .ant-drawer-body {
    padding: 35px 40px;

    .ant-checkbox-wrapper {
      font-size: 14px;
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .ant-drawer-header {
      min-height: fit-content;
      padding: 15px 20px 15px 20px;

      .ant-drawer-header-title {
        display: flex;
        flex-direction: row-reverse;
        .ant-drawer-title {
          font-size: 1rem;
        }
      }
    }

    .ant-drawer-body {
      padding: 16px 16px 80px 16px;
      .ant-form-item {
        margin-bottom: 10px;
        .ant-input {
          border-radius: 3px;
        }
      }
    }

    .ant-drawer-footer {
      padding: 16px;
    }
  }
`;

export const StyledCreateEditUserForm = styled(Form)`
  .ant-form-item-vertical {
    height: 60px;
    margin-bottom: 30px;
  }
`;
